import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { AppUsuarioService } from '../../core/services/appUsuarioService.service';
import { AppEmpresasService } from '../../core/services/appEmpresasService.service';

@Component({
  selector: 'app-importar-excel-dialog',
  templateUrl: './importar-excel-dialog.component.html',
  styleUrls: ['./importar-excel-dialog.component.scss'],
  providers: []
})
export class ImportarExcelDialog {

  // Mapa de funciones
  private templateUrls: { [key: string]: string } = {
    'users': 'https://www.liveshr.com/wp-content/uploads/2024/11/Plantilla_importacion_usuarios_LivesHR.xlsx',
    'companies': 'https://www.liveshr.com/wp-content/uploads/2024/11/Plantilla_importacion_empresas_LivesHR.xlsx',
  };
  private importButtonTexts: { [key: string]: string } = {
    'users': 'Importar empleados',
    'companies': 'Importar empresas',
  };

  panelIcon = 'file-import'; // font awesome icon
  panelTitle = 'Importal desde Excel';
  panelDescription = '';
  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;

  isDragging = false;
  loadedDoc: { filename: string, rows: any[] } | null = { filename: '', rows: [] };
  validatingDoc = false;
  progressValue: number = 0;
  progressText: string = '';
  progressInterval: any;
  @ViewChild('fileInput') fileInput: ElementRef;
  templateType: string = this.data.templateType

  importingDoc = false;
  importingProgressValue: number = 0;
  importingProgressText: string = '';
  importButtonText: string = this.importButtonTexts[this.templateType]




  constructor(
    public dialogRef: MatDialogRef<ImportarExcelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected _messageDialog: MessageDialog,
    private renderer: Renderer2,
    private userService: AppUsuarioService,
    private empresasService: AppEmpresasService,

  ) { }

  closePopUp(response: any) {
    this.dialogRef.close(response);
  }

  downloadTemplate(templateType: string) {
    const selectedUrl = this.templateUrls[templateType];
    if (selectedUrl) {
      const anchor = this.renderer.createElement('a');
      this.renderer.setAttribute(anchor, 'href', selectedUrl);
      this.renderer.setAttribute(anchor, 'download', `template_${templateType}.xlsx`);
      this.renderer.setStyle(anchor, 'display', 'none');
      this.renderer.appendChild(document.body, anchor);
      anchor.click();
      this.renderer.removeChild(document.body, anchor);
    } else {
      console.error(`No se encontró una URL para el tipo de plantilla: ${templateType}`);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.handleFile(event.dataTransfer.files[0]);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFile(input.files[0]);
    }
  }

  handleFile(file: File) {
    const allowedExtensions = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    if (!allowedExtensions.includes(file.type)) {
      console.error('Solo se permiten archivos de Excel (.xlsx o .xls)');
      this._messageDialog.ShowAlert('Solo se permiten archivos de Excel (.xlsx o .xls)', 'Error');
      return;
    }
    this.removeLoadedDoc()
    this.validateDoc(file);
  }

  removeLoadedDoc() {
    this.loadedDoc = { filename: '', rows: [] };
    this.progressValue = 0;
    this.progressText = 'Archivo eliminado.';

    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  validateDoc(file) {
    this.validatingDoc = true;
    this.progressValue = 0;
    this.progressText = 'Validando datos';

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

      const headers: string[] = rows[0] as string[];
      let lastValidRow;

      if (this.templateType === 'users') {
        const expectedHeadersUsers = [
          'NIF (obligatorio)',
          'Correo Electrónico (obligatorio)',
          'Nombre (obligatorio)',
          'Primer Apellido (obligatorio)',
          'Segundo Apellido (opcional)',
          'Código de App de Empresa (obligatorio)',
          'Habilitado (obligatorio)',
          'Enviar invitación (obligatorio)'
        ];
        if (!this.compareHeaders(headers, expectedHeadersUsers)) {
          this.handleValidationError('Los encabezados no son válidos.', file);
          return;
        }
        // Encontrar la última fila con el campo NIF rellenado
        lastValidRow = this.findLastValidRow(rows, headers.indexOf('NIF (obligatorio)')); // Índice de la columna NIF
        if (lastValidRow === 0) {
          this.handleValidationError('No se encontraron datos válidos en el campo NIF.', file);
          return;
        }

      } else {

        const expectedHeadersCompanies = [
          'NIF/CIF (obligatorio)',
          'Nombre (obligatorio)'
        ];
        if (!this.compareHeaders(headers, expectedHeadersCompanies)) {
          this.handleValidationError('Los encabezados no son válidos.', file);
          return;
        }

        // Encontrar la última fila con el campo NIF rellenado
        lastValidRow = this.findLastValidRow(rows, headers.indexOf('NIF/CIF (obligatorio)'));
        if (lastValidRow === 0) {
          this.handleValidationError('No se encontraron datos válidos en el campo NIF/CIF.', file);
          return;
        }
      }



      if (lastValidRow > 1000) {
        this.handleValidationError('El archivo excede las 1000 líneas de datos válidos.', file);
        return;
      }
      // Simular progreso basado en las filas válidas a validar
      this.simulateProgress(lastValidRow, rows, file);
    };

    reader.readAsArrayBuffer(file);
  }

  findLastValidRow(rows, nifColumnIndex) {
    let lastValidRow = 0;
    for (let i = 1; i < rows.length; i++) {
      const row = rows[i];
      const nif = row[nifColumnIndex] || ''; // Campo NIF
      if (nif.trim()) {
        lastValidRow = i;
      }
    }
    return lastValidRow;
  }

  compareHeaders(headers, expectedHeaders) {
    return JSON.stringify(headers) === JSON.stringify(expectedHeaders);
  }

  handleValidationError(errorMessage, file) {
    this.validatingDoc = false;
    this.progressValue = 0;
    this.progressText = errorMessage;

    // Eliminar el archivo
    this.loadedDoc = { filename: '', rows: [] };

    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }

    this._messageDialog.ShowAlert(errorMessage, 'Error');
  }

  simulateProgress(lastValidRow, rows, file) {
    let step = 1; // Comienza en la fila 1 (ignora encabezados)
    const totalSteps = lastValidRow; // Total de filas válidas
    const invalidRows = []; // Array para guardar filas con errores

    // Verificar si solo están los encabezados (archivo vacío)
    if (totalSteps === 0) {
      clearInterval(this.progressInterval);
      this.validatingDoc = false;
      this.loadedDoc = { filename: '', rows: [] };
      this.progressText = 'Error: El archivo está vacío o no contiene datos válidos.';
      this._messageDialog.ShowAlert('El archivo está vacío o no contiene datos válidos.', 'Error');
      return;
    }

    this.progressInterval = setInterval(() => {

      if (step > totalSteps) {
        clearInterval(this.progressInterval);
        this.validatingDoc = false; // Oculta la validación
        this.loadedDoc = {
          filename: file.name,
          rows: [...this.loadedDoc?.rows || []],
        };
        this.progressText = 'Validación completada.';

        if (invalidRows.length > 0) {
          this.generateErrorReport(invalidRows);
          this.removeLoadedDoc();
          this._messageDialog.ShowAlert('El archivo contiene errores, se ha descargado el reporte para que pueda identificarlos y corregirlos', 'Error')
        }

        return;
      }
      const currentRow = rows[step];

      if (currentRow) {

        const errorMessages = [];

        if (this.templateType === 'users') {
          // Asignar valores de los campos a variables
          const nif = currentRow[0] ? currentRow[0].trim() : '';
          const email = currentRow[1] ? currentRow[1].trim() : '';
          const firstName = currentRow[2] ? currentRow[2].trim() : '';
          const lastName = currentRow[3] ? currentRow[3].trim() : '';
          const secondLastName = currentRow[4] ? currentRow[4].trim() : '';
          const appId = currentRow[5] ? currentRow[5].toString().trim() : '';
          const enabled = currentRow[6] ? currentRow[6].trim().toLowerCase() === 'sí' : false; // Convertir a booleano
          const sendInvitation = currentRow[7] ? currentRow[7].trim().toLowerCase() === 'sí' : false;

          // Aplicar expresiones regulares
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Validación de correo electrónico
          const namesRegex = /^[a-zA-ZÁÉÍÓÚáéíóúÑñ\s\-]+$/; // Validación de nombres
          const appIdRegex = /^\d{6}$/; // Validación de appId

          const isNifValid = !!nif;
          const isEmailValid = emailRegex.test(email);
          const isFirstNameValid = namesRegex.test(firstName);
          const isLastNameValid = namesRegex.test(lastName);
          const isSecondLastNameValid = secondLastName ? namesRegex.test(secondLastName) : true;
          const isAppIdValid = appIdRegex.test(appId);

          const isEnabledSendInvitationConflict = !enabled && sendInvitation;


          if (!isNifValid) errorMessages.push('El campo NIF es obligatorio');
          if (!isEmailValid) errorMessages.push('Correo electrónico no válido');
          if (!isFirstNameValid) errorMessages.push('Nombre no válido');
          if (!isLastNameValid) errorMessages.push('Primer apellido no válido');
          if (!isSecondLastNameValid) errorMessages.push('Segundo apellido no válido');
          if (!isAppIdValid) errorMessages.push('El código de App (AppId) debe ser un número de 6 dígitos');
          if (isEnabledSendInvitationConflict) errorMessages.push('No está habilitado, pero tiene activado enviar invitación');

        } else {
          // Asignar valores de los campos a variables
          const nifCif = currentRow[0] ? currentRow[0].trim() : '';
          const name = currentRow[1] ? currentRow[1].trim() : '';

          const isNifCifValid = !!nifCif;
          const isNameValid = !!name;

          if (!isNifCifValid) errorMessages.push('El campo NIF/CIF es obligatorio');
          if (!isNameValid) errorMessages.push('El campo nombre es obligatorio');
        }

        if (errorMessages.length > 0) {
          invalidRows.push({
            rowNumber: step,
            errorMessages: errorMessages // Lista de errores específicos
          });
        } else {
          this.loadedDoc.rows.push(currentRow)
        }
      }

      this.progressValue = Math.min((step / totalSteps) * 100, 100);
      this.progressText = `Validando datos ${step}/${totalSteps}`;
      step++;
    }, 100); // Ajustar el intervalo según sea necesario
  }

  onImport(templateType: string): void {
    switch (templateType) {
      case 'users':
        this.importUsers()
        break;
      case 'companies':
        this.importCompanies()
        break;

      default:
        break;
    }
  }

  importUsers() {
    if (!this.loadedDoc || this.loadedDoc.rows.length === 0) {
      this._messageDialog.ShowAlert('No hay datos cargados para importar.', 'Error');
      return;
    }

    this.importingDoc = true; // Activar indicador de importación
    this.importingProgressValue = 0;
    this.importingProgressText = 'Iniciando importación...';

    const totalRows = this.loadedDoc.rows.length;
    const allRows = [];
    let hasErrors = false; // Indicador de si hubo errores

    const processRow = async (currentRow: number): Promise<void> => {
      const row = this.loadedDoc.rows[currentRow];
      const rowObject = {
        nif: row[0],
        mail: row[1],
        name: row[2],
        surname1: row[3],
        surname2: row[4],
        appId: row[5].toString(),
        enabled: row[6].trim().toLowerCase() === 'sí',
        sendInvitation: row[7].trim().toLowerCase() === 'sí',
      };
      
      try {
        await this.userService.createUserOffline(rowObject).toPromise();
        allRows.push({
          rowNumber: currentRow + 1,
          message: `El empleado con NIF ${rowObject.nif} fue creado correctamente`
        });
      } catch (error) {
        hasErrors = true;
        if (error?.errorCode && error?.errorCode === 'USER_ALREADY_EXISTS') {
          allRows.push({
            rowNumber: currentRow + 1,
            message: `Ya existe un usuario con el NIF ${rowObject.nif} para la empresa ${rowObject.appId}`
          });
        } else {
          allRows.push({
            rowNumber: currentRow + 1,
            message: 'Error desconocido'
          });
        }
      }

      this.importingProgressValue = Math.min(((currentRow + 1) / totalRows) * 100, 100);
      this.importingProgressText = `Importando ${currentRow + 1}/${totalRows}`;
    };

    const importAllRows = async () => {
      for (let currentRow = 0; currentRow < totalRows; currentRow++) {
        await processRow(currentRow);
      }

      this.importingDoc = false; // Finalizar importación
      this.importingProgressText = 'Importación completada.';

      if (hasErrors) {
        this.generateExcel(allRows);
        this._messageDialog.ShowAlert('Algunos empleados no pudieron ser importados, revise el reporte para más información', 'Error al importar empleados')
      } else {
        this._messageDialog.ShowMessage('Todos los empleados fueron importados correctamente', 'Empleados importados correctamente')

      }
    };

    importAllRows();
  }

  importCompanies() {
    if (!this.loadedDoc || this.loadedDoc.rows.length === 0) {
      this._messageDialog.ShowAlert('No hay datos cargados para importar.', 'Error');
      return;
    }

    this.importingDoc = true; // Activar indicador de importación
    this.importingProgressValue = 0;
    this.importingProgressText = 'Iniciando importación...';

    const totalRows = this.loadedDoc.rows.length;
    const allRows = [];
    let hasErrors = false; // Indicador de si hubo errores

    const processRow = async (currentRow: number): Promise<void> => {
      const row = this.loadedDoc.rows[currentRow];
      const rowObject = {
        identifierNumber: row[0],
        name: row[1],
      };

      try {
        await this.empresasService.createModelOffline(rowObject).toPromise();
        allRows.push({
          rowNumber: currentRow + 1,
          message: `La empresa ${rowObject.name} fue creadoa correctamente`
        });
      } catch (error) {
        hasErrors = true;

        if (error.status === 409) {
          allRows.push({
            rowNumber: currentRow + 1,
            message: `Ya existe una empresa con el NIF/CIF ${rowObject.identifierNumber}`
          });
        } else {
          allRows.push({
            rowNumber: currentRow + 1,
            message: 'Error desconocido'
          });
        }
      }

      this.importingProgressValue = Math.min(((currentRow + 1) / totalRows) * 100, 100);
      this.importingProgressText = `Importando ${currentRow + 1}/${totalRows}`;
    };

    const importAllRows = async () => {
      for (let currentRow = 0; currentRow < totalRows; currentRow++) {
        await processRow(currentRow);
      }

      this.importingDoc = false; // Finalizar importación
      this.importingProgressText = 'Importación completada.';

      if (hasErrors) {
        this.generateExcel(allRows);
        this._messageDialog.ShowAlert('Algunas empresas no pudieron ser importadas, revise el reporte para más información', 'Error al importar empresas')
      } else {
        this._messageDialog.ShowMessage('Todas las empresas fueron importadas correctamente', 'Empresas importados correctamente')

      }
    };

    importAllRows();
  }

  generateErrorReport(invalidRows: any[]) {
    // Crear los datos para el Excel
    const reportData = invalidRows.map((row) => ({
      'Número de Fila': row.rowNumber,
      'Errores': row.errorMessages.join(', ')
    }));

    // Definir el ancho de las columnas
    const wscols = [
      { wch: 40 }, // Ancho de la primera columna
      { wch: 100 } // Ancho de la segunda columna
    ];

    // Crear el libro y la hoja
    const worksheet = XLSX.utils.json_to_sheet(reportData);
    worksheet['!cols'] = wscols; // Aplicar el ancho a las columnas

    // Alinear columnas a la izquierda
    Object.keys(worksheet).forEach((key) => {
      if (key.startsWith('A') || key.startsWith('B')) {
        worksheet[key].s = { alignment: { horizontal: 'left' } };
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Errores');

    // Convertir el libro a Blob
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // Crear un enlace dinámico para descargar
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Reporte_Errores.xlsx';
    link.click();

    // Liberar la URL
    URL.revokeObjectURL(link.href);
  }

  generateExcel(errorRows: any[]) {
    // Crear los datos para el Excel
    const reportData = errorRows.map((error) => ({
      'Número de Fila': error.rowNumber,
      'Mensaje': error.message
    }));

    // Configurar las columnas para el Excel
    const wscols = [
      { wch: 15 }, // Ancho de la columna para 'Número de Fila'
      { wch: 100 }  // Ancho de la columna para 'Mensaje'
    ];

    // Crear la hoja de Excel
    const worksheet = XLSX.utils.json_to_sheet(reportData);
    worksheet['!cols'] = wscols; // Aplicar ancho a las columnas

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');

    // Convertir el libro a un Blob para descargar
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // Crear un enlace dinámico para descargar el archivo
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Reporte_importacion.xlsx';
    link.click();

    // Liberar la URL
    URL.revokeObjectURL(link.href);
  }

}